import React from "react";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import WhatsAppButton from "./WhatsAppButton";
// import WelcomePopup from "./popup/WelcomePopUs";

const Layout = () => {
  return (
    <>
      {/* <WelcomePopup /> */}
      <ScrollToTop />
      <Header />
      <Outlet />
      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default Layout;
